import { Icon } from "@iconify/react";
import { createUseStyles } from "react-jss";
import _ from "lodash";
import { useContext } from "react";
import { StyleTypeContext } from "../../umbilical_tools";
import jssVariables from "../../jss_setup";

const styles = createUseStyles({
  "@keyframes modl": {
    from: {
      background: "rgba(255,255,255,0)",
      backdropFilter: "blur(0px)",
    },
    to: {
      background: "rgba(255,255,255,0.3)",
      backdropFilter: "blur(5px)",
    },
  },
  FullScreenLoader: {
    left: 0,
    top: 0,
    width: "100vw",
    height: "100vh",
    zIndex: 9999,
    background: "rgba(255,255,255,0.3)",
    backdropFilter: "blur(5px)",
    animationDuration: ".3s",
    animationName: "$modl",
  },
  iconContainer: {
    position: "absolute",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)",
    display: "grid",
    gridGap: jssVariables.normal_gap,
    placeItems: "center",
  },
  icon: (props: any) => ({
    height: "5rem",
    width: "5rem",
    color: jssVariables.colors.base_color,
    ...(props?.customStyles?.icon ?? {}),
  }),
  text: (props: any) => ({
    fontSize: "large",
    fontWeight: "bold",
    color: jssVariables.colors.base_color,
    ...(props?.customStyles?.text ?? {}),
  }),
});
type FullScreenLoaderProps = {
  text?: string;
};
export default function FullScreenLoader({ text }: FullScreenLoaderProps) {
  const { type, brand, cStyler } = useContext(StyleTypeContext);

  const classes = styles({
    type,
    customStyles: cStyler({
      type,
      brand,
      objName: "FullScreenLoader",
    }),
  });
  return (
    <div className={classes.FullScreenLoader}>
      <div className={classes.iconContainer}>
        <Icon className={classes.icon} icon="eos-icons:loading" />
        <span className={classes.text}>{text}</span>
      </div>
    </div>
  );
}
